import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled, { injectGlobal, keyframes } from 'styled-components'
import mapboxgl from 'mapbox-gl'
import { Link } from 'react-router-dom'
import AngleRight from 'react-icons/lib/fa/angle-right'

import { Flex, Relative } from './common'
import BackgroundImage from './BackgroundImage'

const fadeInUp = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`
const PopupInner = styled.div``
const PopupContent = styled(Flex)`
  padding: 0.5rem;
`
const PopupTitle = styled.h5`
  margin: 0;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 1rem;
`
const PopupImage = styled(Relative)`
  height: 7rem;
  width: 100%;
  min-width: 14rem;
`
const ViewLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  color: inherit;
  margin-left: 1rem;
  margin-top: 0;
  text-transform: uppercase;
  font-weight: 400;
`
const ViewDiv = ViewLink.withComponent('div')
const markerGlobalStyle = () => injectGlobal`
  .mapboxgl-popup {
    animation: ${fadeInUp} .2s ease-out;

    .mapboxgl-popup-content {
      padding: 0;
    }
    .mapboxgl-popup-close-button {

    }
  }
`
markerGlobalStyle()

class MarkerPopup extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isOpen: false,
      center: this.props.center,
      popup: null,
      offset: this.props.markerHeight || 0
    }
    this.htmlNode = null
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (nextProps.infoVisible !== this.state.infoVisible) return true
    return false
  }

  componentDidMount () {
    const popup = new mapboxgl.Popup({
      offset: this.state.offset,
      closeOnClick: false,
      closeButton: false,
      anchor: 'bottom'
    })
      .setLngLat(this.state.center)
      .setDOMContent(this.htmlNode)

    this.setState({ popup: popup })
  }

  componentDidUpdate () {
    if (this.props.infoVisible) {
      this.state.popup.addTo(this.props.map)
    } else {
      this.state.popup.remove()
    }
  }

  render () {
    const { image, to, title, renderAsLink } = this.props

    return (
      <PopupInner
        innerRef={me => {
          this.htmlNode = me
        }}
      >
        {image &&
          false && (
            <PopupImage>
              <BackgroundImage image={image} />
            </PopupImage>
          )}
        <PopupContent alignCenter>
          {renderAsLink ? (
            <ViewLink to={to}>
              <PopupTitle>{title}</PopupTitle>
              <AngleRight />
            </ViewLink>
          ) : (
            <ViewDiv to={to}>
              <PopupTitle>{title}</PopupTitle>
              <AngleRight />
            </ViewDiv>
          )}
        </PopupContent>
      </PopupInner>
    )
  }
}

MarkerPopup.propTypes = {
  title: PropTypes.string.isRequired,
  center: PropTypes.array || PropTypes.object,
  map: PropTypes.any,
  markerHeight: PropTypes.number,
  infoVisible: PropTypes.bool,
  image: PropTypes.string,
  to: PropTypes.string.isRequired
}

export default MarkerPopup



// WEBPACK FOOTER //
// ./src/components/MarkerPopup.js